export default __webpack_public_path__ + "static/media/ic_add_circle_app.2ce556fc.svg";